import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FilePlus2, History, User, Clock, Shield } from "lucide-react";
import { Logo } from "@/components/Shared";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/reports/new", label: "New Report", icon: FilePlus2, id: "new-report" },
  { to: "/history", label: "History", icon: History, id: "history" },
  { to: "/timesheet", label: "Timesheet", icon: Clock, id: "timesheet" },
  { to: "/account", label: "Account", icon: User, id: "account" },
];

export default function EmployeeLayout() {
  const { user } = useAuth();
  const tsOnly = user?.timesheet_only && user.role === "employee";
  const nav = tsOnly ? NAV.filter((n) => ["timesheet", "account"].includes(n.id)) : NAV;
  const home = tsOnly ? "/timesheet" : "/dashboard";
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b border-border bg-white/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-3xl items-center justify-between px-4">
          <Link to={home} data-testid="header-home-link"><Logo className="h-9" /></Link>
          <nav className="hidden items-center gap-1 md:flex">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} end data-testid={`top-nav-${n.id}`}
                className={({ isActive }) => cn("rounded-md px-3 py-2 text-sm font-semibold transition-colors", isActive ? "bg-[#5C241E] text-white" : "text-slate-700 hover:text-[#5C241E]")}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <span className="text-sm font-medium text-slate-600 md:hidden" data-testid="header-user-name">{user?.first_name}</span>
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="back-to-admin-link" className="ml-2 inline-flex h-9 items-center gap-1 rounded-md bg-[#5C241E] px-3 text-sm font-semibold text-white"><Shield className="h-4 w-4" />Admin</Link>
          )}
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 pb-28 pt-5 md:pb-12">
        <Outlet />
      </main>
      <nav className="pb-safe fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white md:hidden" data-testid="mobile-bottom-nav">
        <div className={cn("grid", nav.length === 2 ? "grid-cols-2" : "grid-cols-5")}>
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`mobile-nav-${n.id}`}
              className={({ isActive }) => cn("flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors", isActive ? "text-[#5C241E]" : "text-slate-500")}>
              {({ isActive }) => (
                <>
                  <span className={cn("flex h-8 w-12 items-center justify-center rounded-full transition-colors", isActive && "bg-[#5C241E]/10")}>
                    <n.icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
                  </span>
                  {n.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
